import React, { useEffect, useState } from 'react';
import Dropdown from './Dropdown';
import { DefaultDropdownProps, Option } from './dropdownHelper';
import { ResultResourceData } from 'framework/crud';
import useInputHelper from './inputHelper';
import { SelectComponentsConfig } from 'react-select';
import InputLoader from '../../ui/mui-builder/Loading/InputLoader';

interface LoadDropdownProps extends DefaultDropdownProps {
  loadDataMethod: () => ResultResourceData;
  mapResults?: (data: any) => Option;
  mapResult?: (data: any) => Option[];
  onChangeCallback?: any;
  showLoader?: boolean;
  components?: SelectComponentsConfig<any, any, any>;
  deps?: any[];
  isClearValueByUpdateDeps?: boolean;
}

const LoadDropdown = ({
  loadDataMethod,
  mapResults,
  mapResult,
  onChangeCallback,
  showLoader = false,
  disabled,
  deps = [],
  isClearValueByUpdateDeps = false,
  ...props
}: LoadDropdownProps) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getRawOnChangeCallback } = useInputHelper({ source: props.source });
  const parentOnChange = getRawOnChangeCallback() || (() => {});

  useEffect(() => {
    const loadData = async () => {
      try {
        const { result } = await loadDataMethod();
        if (mapResult) {
          const mappedOptions: any = mapResult(result);
          setOptions(mappedOptions);
        } else if (mapResults) {
          setOptions(result.map(mapResults));
        } else {
          setOptions(result);
        }
      } catch (error) {
        throw new Error(error as string);
      } finally {
        setLoading(false);
      }
    };

    if (loading) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  useEffect(() => {
    setLoading(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled, ...deps]);

  useEffect(() => {
    if (isClearValueByUpdateDeps) {
      parentOnChange({
        [props.source]: null,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClearValueByUpdateDeps, ...deps]);

  if (showLoader && loading) {
    return <InputLoader />;
  } else {
    return (
      <Dropdown
        isLoading={loading}
        options={options}
        onChangeCallback={onChangeCallback}
        disabled={disabled}
        {...props}
      />
    );
  }
};

export default LoadDropdown;
